import parseISO from 'date-fns/parseISO';
import { ApiTransaction, TransactionStatus, TransactionType } from './ApiTransaction';

export class Transaction
  implements Omit<ApiTransaction, 'leftAt' | 'leftApprovedAt' | 'returnedAt' | 'returnApprovedAt'>
{
  id = this.transaction.id;
  assetId = this.transaction.assetId;
  assetTitle = this.transaction.assetTitle;
  assetGuid = this.transaction.assetGuid;
  customerId = this.transaction.customerId;
  customerName = this.transaction.customerName;
  type: TransactionType = this.transaction.type;
  status: TransactionStatus = this.transaction.status;
  sourceSiteId = this.transaction.sourceSiteId;
  destinationSiteId = this.transaction.destinationSiteId;
  sourceSiteName = this.transaction.sourceSiteName;
  destinationSiteName = this.transaction.destinationSiteName;
  leftAt = this.transaction.leftAt ? parseISO(this.transaction.leftAt) : null;
  leftApprovedAt = this.transaction.leftApprovedAt ? parseISO(this.transaction.leftApprovedAt) : null;
  leftApprovedBy = this.transaction.leftApprovedBy;
  returnedAt = this.transaction.returnedAt ? parseISO(this.transaction.returnedAt) : null;
  returnApprovedAt = this.transaction.returnApprovedAt ? parseISO(this.transaction.returnApprovedAt) : null;
  returnApprovedBy = this.transaction.returnApprovedBy;

  constructor(private transaction: ApiTransaction) {}

  get isPending(): boolean {
    return this.status === 'pending_checkout' || this.status === 'pending_return';
  }

  get isConfirmed(): boolean {
    return this.status === 'active' || this.status === 'completed';
  }
}
